import React from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import ImgCss from "../Material/icons8-css3-100.png";
import ImgHtml from "../Material/icons8-html-5-100.png";
import ImgGit from "../Material/icons8-github-120.png";
import ImgJS from "../Material/icons8-javascript-100.png";
import ImgTypeScript from "../Material/icons8-typescript-100.png";
import ImgMySql from "../Material/icons8-mysql-logo-100.png";
import ImgMongodb from "../Material/icons8-mongodb-144.png";
import ImgReact from "../Material/icons8-react-160.png";
import ImgRedux from "../Material/icons8-redux-500.png";
import ImgNextJs from "../Material/icons8-nextjs-100.png";
import ImgNodeJs from "../Material/icons8-nodejs-100.png";
import ImgNestJs from "../Material/icons8-nestjs-100.png";
import ImgAWS from "../Material/icons8-aws-100.png";
import ImgMaterialUI from "../Material/icons8-material-ui-100.png";
import "./Tech.css";
const TechStack = () => {
  AOS.init();
  return (
    <div className="TechMainContainer">
      <h1>Tech Stack</h1>
      
      {/* Frontend Technologies */}
      <h2 className="tech-category">Frontend</h2>
      <div
        data-aos="fade-up"
        data-aos-offset="10"
        data-aos-delay="50"
        data-aos-duration="1000"
        data-aos-easing="ease-in-out"
        data-aos-mirror="true"
        data-aos-once="false"
        data-aos-anchor-placement="top-center"
        className="TechContainer"
      >
        <div>
          <img src={ImgReact} alt="react" />
          <h5>React</h5>
        </div>
        <div>
          <img src={ImgNextJs} alt="nextjs" />
          <h5>Next.js</h5>
        </div>
        <div>
          <img src={ImgRedux} alt="redux" />
          <h5>Redux</h5>
        </div>
        <div>
          <img src={ImgJS} alt="javascript" />
          <h5>JavaScript</h5>
        </div>
        <div>
          <img src={ImgTypeScript} alt="typescript" />
          <h5>TypeScript</h5>
        </div>
        <div>
          <img src={ImgHtml} alt="html" />
          <h5>HTML5</h5>
        </div>
        <div>
          <img src={ImgCss} alt="css" />
          <h5>CSS3</h5>
        </div>
        <div>
          <img src={ImgMaterialUI} alt="material-ui" />
          <h5>Material UI</h5>
        </div>
      </div>

      {/* Backend Technologies */}
      <h2 className="tech-category">Backend & Database</h2>
      <div
        data-aos="fade-up"
        data-aos-offset="10"
        data-aos-delay="50"
        data-aos-duration="1000"
        data-aos-easing="ease-in-out"
        className="TechContainer"
      >
        <div>
          <img src={ImgNodeJs} alt="nodejs" />
          <h5>Node.js</h5>
        </div>
        <div>
          <img src={ImgNestJs} alt="nestjs" />
          <h5>NestJS</h5>
        </div>
        <div>
          <img src={ImgMongodb} alt="mongodb" />
          <h5>MongoDB</h5>
        </div>
        <div>
          <img src={ImgMySql} alt="mysql" />
          <h5>MySQL</h5>
        </div>
      </div>

      {/* Tools & DevOps */}
      <h2 className="tech-category">Tools & DevOps</h2>
      <div
        data-aos="fade-up"
        data-aos-offset="10"
        data-aos-delay="50"
        data-aos-duration="1000"
        data-aos-easing="ease-in-out"
        className="TechContainer"
      >
        <div>
          <img src={ImgGit} alt="git" />
          <h5>Git</h5>
        </div>
        <div>
          <img src={ImgAWS} alt="aws" />
          <h5>AWS</h5>
        </div>
      </div>
    </div>
  );
};
export default TechStack;
